





































import VueOptions from '@utils/VueOptions'

settings =
  name: 'EventInstances'

  vue:
    props: ['selectedIds', 'event', 'eventInstancesList', 'actions']

    computed:
      instanceEvents: ->
        [...@eventInstancesList].sort((a, b) ->
          isBefore = dayjs(a.local_start_day).isBefore(b.local_start_day)
          return if not isBefore then 1 else if isBefore then -1 else 0
        )

    methods:
      isSelected: (instance) -> instance.id in (@selectedIds || [])
      eventDate: (instance) -> @$options.filters.formatDateWindow(instance.local_start_day, instance.local_end_day)

export default VueOptions.vue settings
